<!-- Menu header -->
<div class="navbar-header mb-25" style="background: #fff !important; border-bottom: solid 2px #f1f1f1;">
    <ul class="nav navbar-nav flex-row">
        <li class="nav-item mr-auto">
            <!-- App Branding -->
            <a class="navbar-brand" [routerLink]="['/']">
                <span>
                    <img src="assets/images/logo/logo.png" alt="brand-logo" style="margin-top: -24px;
                  width: 56%;
                  margin-left: 50px;" />
                </span>
            </a>
        </li>

        <!-- Menu Toggler -->
        <li class="nav-item nav-toggle">
            <a class="nav-link modern-nav-toggle d-none d-xl-block pr-0" (click)="toggleSidebarCollapsible()">
                <i [ngClass]="isCollapsed === true ? 'icon-circle' : 'icon-disc'"
                    class="toggle-icon feather font-medium-4 collapse-toggle-icon" style="color: #7a1fa2 !important;">
                </i>
            </a>
            <a class="nav-link modern-nav-toggle d-block d-xl-none pr-0" (click)="toggleSidebar()">
                <i data-feather="x" class="font-medium-4 toggle-icon close-menu" style="color: #7a1fa2 !important;"></i>
            </a>
        </li>
    </ul>
</div>
<!--/ Menu header -->


<!-- Main menu -->
<div class="main-menu-content" [perfectScrollbar] (scroll)="onSidebarScroll()">
    <ul class="navigation navigation-main pt-1" layout="vertical" core-menu></ul>
</div>
<!--/ Main menu -->